module.exports = __webpack_public_path__ + "img/dotted-point-arrow.0ae90e9d.svg";